import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f0f2f5;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 20px;
`;

const Header = styled.header`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #007bff;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #333;
  max-width: 600px;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
`;

const Button = styled.a`
  display: inline-block;
  padding: 10px 20px;
  font-size: 1rem;
  color: #fff;
  background-color: #007bff;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    padding: 10px 15px;
    font-size: 0.9rem;
  }
`;

const Home: React.FC = () => {
  return (
    <Container>
      <Header>
        <Title>Bienvenue chez AUNE</Title>
        <Subtitle>
          La plateforme ultime pour partager vos vidéos professionnelles. Rejoignez-nous et découvrez un monde de possibilités.
        </Subtitle>
        <ButtonContainer>
          <Button href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
            Télécharger sur Play Store
          </Button>
          <Button href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
            Télécharger sur App Store
          </Button>
        </ButtonContainer>
      </Header>
    </Container>
  );
};

export default Home;
